import React, { Component } from 'react';
import { TweenMax, Power3, Back } from "gsap";
import getRandomFromRange from "../../utils/getRandomFromRange";

class Wheel extends Component {
    constructor( props ){
        super( props );

        this.state = {
            containerWidth: 0
        };

        this.tweenWheel = null;
        this.segmentAngle = 360 / this.props.assetConfig.wheel.segments;

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount(){
        TweenMax.set( this.pin, {
            transformOrigin: this.props.assetConfig.pin.rotationPoint || '50% 25%'
        });

        window.addEventListener("resize", this.updateDimensions );
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions );
    }

    componentWillReceiveProps( nextProps ) {
        if( this.props.segmentTarget !== nextProps.segmentTarget ) {
            this.spin( nextProps.segmentTarget );
        }
    }

    spin( segmentNumber ){
        if ( !segmentNumber ) return;

        const durationRange = this.props.duration || [10, 12];
        const duration = getRandomFromRange( durationRange[0], durationRange[1] );
        const spinRange = this.props.spinCount || [10, 12];
        const spins = getRandomFromRange( spinRange[0], spinRange[1] );
        const stopAngle = ( this.segmentAngle * segmentNumber ) - getRandomFromRange( 5, this.segmentAngle - 5 );

        if( this.tweenWheel ) {
            this.tweenWheel.seek(0);
            this.tweenWheel.kill();
        }
        
        this.tweenWheel = TweenMax.to(this.wheel, duration, {
            rotation: ( spins * 360 ) + ( 360 - stopAngle ),
            repeat : 0,
            ease : Power3.easeOut,
            onUpdate: () => { this.animatePin(); },
            onStart: this.props.onStart,
            onComplete: this.props.onComplete
        });
    }

    animatePin(){
        this.position = this.position || {};
        this.position.old = this.position.current;
        this.position.current = Math.round( this.wheel._gsTransform.rotation / this.segmentAngle );
    
        if (this.position.current !== this.position.old) {
            var rotation = ( this.position.current > this.position.old ) ? -35 : 35;
    
            TweenMax.fromTo( this.pin, 0.2, {
                rotation: rotation
            }, {
                rotation: 0,
                ease: Back.easeOut
            });
        }
    }

    updateDimensions(){
        this.setState({
            containerWidth: this.container.offsetWidth
        });
    }

    render() {
        const className = this.props.className || '';
        const pinConfig = this.props.assetConfig.pin;
        const wheelConfig = this.props.assetConfig.wheel;

        return (
            <div className={ `SpinToWinWheel ${ className }` } ref={ (el) => this.container = el }  style={{ height: this.state.containerWidth }}>
                <img 
                    className="SpinToWinWheel-pin"
                    ref={ (el) => this.pin = el } 
                    src={ pinConfig.url } 
                    width={  pinConfig.width } 
                    height={ pinConfig.height } 
                    alt=""/>
                <img 
                    className="SpinToWinWheel-wheel"
                    onLoad={ this.updateDimensions }
                    ref={ (el) => this.wheel = el } 
                    src={ wheelConfig.url } 
                    width={ wheelConfig.width } 
                    height={ wheelConfig.width } 
                    alt=""/>
            </div>
        );
    }
}

export default Wheel;



// WEBPACK FOOTER //
// ./src/components/Wheel/Wheel.js